module.exports = __webpack_public_path__ + "img/illustration_staff_HCP@2x.3ce5af2f.png";